// Maximum number of tickers allowed in a single prioritized ticker list
// (Watchlist, Readylist, and the other screener pages that use the same
// "prioritized list with an Add box" pattern: HVol, GLeaderDetails,
// Minervini, ThemeDetails, Inverses, Steroids).
//
// Keep this in sync with backend/app/api/list_limits.py, which enforces the
// same cap server-side on every promote/demote route that feeds these lists.
export const MAX_TICKER_LIST_SIZE = 18;

// Basing has its own, larger cap so it doesn't share MAX_TICKER_LIST_SIZE
// above. Keep in sync with BASING_LIMIT in backend/app/api/list_limits.py.
export const MAX_BASING_LIST_SIZE = 36;

// VCP has its own cap so it doesn't share MAX_TICKER_LIST_SIZE above. Keep
// in sync with VCP_LIMIT in backend/app/api/list_limits.py.
export const MAX_VCP_LIST_SIZE = 18;
